/**
 * 돈 계산의 바탕 셈. 소수를 쓰지 않고 정수(BigInt)로만 셈해 오차를 없앤다.
 * 소수로 셈하면 1,700,000 x 0.9%가 15,299.99...가 되어 15,290원으로 잘리는 실수가 난다(2026-10-24 검산에서 잡음).
 * 퍼센트는 화면에 보이는 숫자 그대로(10%는 10, 0.9%는 0.9) 받고, 안에서는 만분의 일 단위(10% = 100,000)로 바꾼다.
 */

/** 퍼센트를 백만분율 정수로(소수 넷째 자리까지, 데이터베이스 numeric(7, 4)와 같음) */
export function bp(pct: number): bigint {
  const v = Math.round(pct * 10000);
  if (!Number.isFinite(pct) || Math.abs(pct * 10000 - v) > 1e-6) throw new Error('퍼센트는 소수 넷째 자리까지입니다.');
  return BigInt(v);
}

export const ONE = 1_000_000n;

export function big(n: number): bigint {
  if (!Number.isSafeInteger(n)) throw new Error('금액은 원 단위 정수여야 합니다.');
  return BigInt(n);
}

export function num(n: bigint): number {
  return Number(n);
}

/** 0 이상 분수의 반올림(0.5는 올림). 돈 계산에는 음수 분수가 나오지 않는다. */
export function roundHalf(numerator: bigint, denominator: bigint): bigint {
  return (2n * numerator + denominator) / (2n * denominator);
}

/** 0 이상 분수의 내림 */
export function floorDiv(numerator: bigint, denominator: bigint): bigint {
  return numerator / denominator;
}

/** 10원 미만 버림(세금과 보험 끝전, 세무사 확인 2026-10-24) */
export function floor10(n: bigint): bigint {
  return floorDiv(n, 10n) * 10n;
}

/** 금액 x 퍼센트, 원 미만 반올림 */
export function pctRound(amount: bigint, pct: number): bigint {
  return roundHalf(amount * bp(pct), ONE);
}

/** 단가 x 공수(소수 둘째 자리까지), 원 미만 반올림 */
export function timesGongsu(price: bigint, gongsu: number): bigint {
  const g = Math.round(gongsu * 100);
  if (Math.abs(gongsu * 100 - g) > 1e-6 || g < 0) throw new Error('공수는 소수 둘째 자리까지입니다.');
  return roundHalf(price * BigInt(g), 100n);
}
